export default __webpack_public_path__ + "static/media/ap logo marketplace.1ce82708.png";